import React, { Suspense, lazy } from "react";
import { aiAgentsCluster, getRelatedMoneyPages, getRelatedIndustryPages, getRelatedInsightPages } from "@/data/contentClusters";

const MoneyPageTemplate = lazy(() => import("@/components/templates/MoneyPageTemplate").then((m) => ({ default: m.MoneyPageTemplate })));

const pageData = aiAgentsCluster.moneyPages.find(p => p.slug === "customer-support")!;
const relatedMoney = getRelatedMoneyPages("ai-agents").filter(p => p.slug !== pageData.slug);
const relatedIndustry = getRelatedIndustryPages("ai-agents");
const relatedInsights = getRelatedInsightPages("ai-agents");

export default function CustomerSupportPage() {
  return (
    <Suspense fallback={<div className="container-wide py-24">Loading…</div>}>
      <MoneyPageTemplate
        page={pageData}
        pillarTitle={aiAgentsCluster.pillar.subtitle}
        relatedMoneyPages={relatedMoney.map((p) => ({ title: p.title, slug: p.slug }))}
        relatedIndustryPages={relatedIndustry.map((p) => ({ title: p.title, slug: p.slug }))}
        relatedInsightPages={relatedInsights.map((p) => ({ title: p.title, slug: p.slug }))}
      />
    </Suspense>
  );
}
